module.exports = __webpack_public_path__ + "img/lt.6739cd1b.svg";